<template>
  <div class="archive-collection">
    <div class="archive-collection__item is-header">
      <h3 class="title is-3" v-html="titleText(collection)"></h3>
    </div>

    <a v-for="(group, groupIndex) in groups"
       :key="`group-${groupIndex}`"
       class="archive-collection__item"
       :class="{ 'is-expanded': group.expanded }"
       @click="showCollectionItem(group)">

       <ArchiveCollectionItem :itemData="group.objects"
                              :title="group.title"
                              :caption="group.caption"></ArchiveCollectionItem>
    </a>

    <!-- Single items -->
    <a v-for="(object, objIndex) in ungroupedObjects"
       :key="`ungrouped-obj-${objIndex}`"
       class="archive-collection__item"
       @click="showCollectionItem(object)">
      <ArchiveCollectionItem :itemData="object"
                             :title="object.title"
                             :caption="object.caption"></ArchiveCollectionItem>
    </a>
  </div>
</template>

<script>
import ArchiveCollectionItem from '@/components/ArchiveCollectionItem.vue'
import { markdown } from '@/utils.js'
export default {
  name: 'archiveCollection',
  components: { ArchiveCollectionItem },
  props: ['collection', 'objects'],

  computed: {
    groups () {
      let namedGroups = this.collection.groups.filter(group => {
        if ('title' in group) { return group }
      })

      return namedGroups.map(group => {
        return {
          title: group.title,
          caption: group.caption,
          objects: this.getObjectsByIds(group.entries)
        }
      })
    },

    ungroupedObjects () {
      let unnamedGroups = this.collection.groups.filter(group => {
        if (!('title' in group)) { return group }
      })

      let ungroupedObjectIds = unnamedGroups.reduce((flattened, group) => {
        group.entries.forEach(entry => { flattened.push(entry) })
        return flattened
      }, [])

      return this.getObjectsByIds(ungroupedObjectIds)
    }
  },

  methods: {
    // the markdown function will output the text to include <p>
    // tags, they aren't needed in the title, so are stripped here
    titleText (object) {
      if (object.name) {
        let str = this.markdown(object.name)
        return str.replace(/<\/*p>/g, '').trim()
      } else {
        return ''
      }
    },

    getObjectById (id) {
      return this.objects.find(object => {
        return object.id === id
      })
    },

    getObjectsByIds (ids) {
      return ids.map(id => { return this.getObjectById(id) })
    },

    showObject (id) {
      let object = this.getObjectById(id)
      this.$emit('open-details', object)
    },

    showCollectionItem (item) {
      this.$emit('open-details', item)
    },

    markdown: markdown
  }
}
</script>

<style lang="scss">
@import "../assets/styles/main.scss";

$archive-collection-border: solid 1px $grey;

.archive-collection {
  display: grid;
  grid-template-rows: auto;
  grid-auto-rows: minmax(200px, auto);;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-row-gap: 1rem;
  grid-column-gap: 1rem;
  margin-bottom: 50px;

  &__item {
    // border: $archive-collection-border;
    padding: 1rem;

    &__objects {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-auto-rows: 1fr;
      grid-row-gap: 1rem;
      grid-column-gap: 1rem;

      &__item {
        // border: $archive-collection-border;
        padding: 1rem;

        .title,
        .subtitle {
          font-size: 0.85em;
        }
      }
    }

    &.is-header {
      border: 0;
      border-bottom: $archive-collection-border;
      padding: 0;
      padding-bottom: 0.5em;
      grid-column-start: 1;
      grid-column-end: 5;

      .title,
      .subtitle {
      }
    }

    &.is-expanded {
      grid-column-start: 1;
      grid-column-end: 5;
    }

    .content {
      margin-bottom: 1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ArchiveCollection.vue?4aa5e30c